import { render, staticRenderFns } from "./KanbanConsolidado.vue?vue&type=template&id=143c8ad6&scoped=true&"
import script from "./KanbanConsolidado.vue?vue&type=script&lang=js&"
export * from "./KanbanConsolidado.vue?vue&type=script&lang=js&"
import style0 from "./KanbanConsolidado.vue?vue&type=style&index=0&id=143c8ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143c8ad6",
  null
  
)

export default component.exports